@use '@/sass/variables';

@keyframes warningAlertAnimation {
  from {
    transform: rotateX(90deg);
    opacity: 0;
  }
  to {
    transform: rotateX(0deg);
    opacity: 1;
  }
}

.warningAlert {
  width: 24rem;
  box-shadow: variables.$black-50 0 5px 15px;
  animation: warningAlertAnimation 300ms ease-in;
  animation-fill-mode: both;
}

.criticalAlertContainer {
  width: 24rem;
}

.warningAlertContainer {
  z-index: 501;
}

.alertInfoBox {
  padding: 0.9375rem;
}

.alertIcon {
  min-width: 24px;
}
